'use strict';

angular.module('imagetrend.components')
    .controller('hlpVoucherPayController', ['$scope', 'DataElements', 'VoucherPay',
        function ($scope, DataElements, VoucherPay) {
            $scope.component.elementAnswer = [];

            $scope.compareAmounts = function (a, b) {
                if (parseFloat(a.amount) < parseFloat(b.amount)) { return -1; }
                if (parseFloat(a.amount) > parseFloat(b.amount)) { return 1; }
                return 0;
            }

            VoucherPay.getExistingVouchersByLicenseRequestID($scope.parameters.license_request_id).then(function (existingVouchers) {
                DataElements.getVoucherAmounts({}).then(function (voucherAmounts) {
                    if (voucherAmounts) {
                        //Match existing amounts to data elements
                        voucherAmounts.forEach(function (voucherAmount) {
                            if (existingVouchers) {
                                var found = false;
                                existingVouchers.forEach(function (existingVoucher) {
                                    if (!found && existingVoucher.amount.toFixed(2).toString() == voucherAmount.name) {
                                        $scope.component.elementAnswer.push({ "amount": voucherAmount.name, "quantity": existingVoucher.quantity });
                                        found = true;
                                        existingVoucher.found = true;
                                    }
                                });
                                if (!found) {
                                    $scope.component.elementAnswer.push({ "amount": voucherAmount.name, "quantity": 0 });
                                }
                            }
                            else {
                                $scope.component.elementAnswer.push({ "amount": voucherAmount.name, "quantity": 0 });
                            }
                        })
                        var reorder = false;
                        //For situations where the data element amounts have been changed but vouchers were already requested with the old amounts
                        existingVouchers.forEach(function (existingVoucher) {
                            if (existingVoucher.found != true) {
                                reorder = true;
                                $scope.component.elementAnswer.push({ "amount": existingVoucher.amount.toFixed(2).toString(), "quantity": existingVoucher.quantity });
                            }
                        });
                        if (reorder == true) {
                            $scope.component.elementAnswer.sort($scope.compareAmounts);
                        }
                    }
                });
            });
        }])
    .directive('hlpVoucherPay', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/voucher-pay/voucher-pay.html',
            replace: true,
            controller: 'hlpVoucherPayController',
            scope: {
                parameters: '=?',
                component: '=?',
                pdf: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;